// Parsing of amounts typed by a Swedish user: "1 000,50", "1 000.50" and
// "1000,50" must all mean the same thing. parseFloat stops at the first
// space, so "1 000" would silently become 1 kr.
export const parseAmount = (value: string | number | null | undefined): number | null => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (value == null) return null;
  const cleaned = String(value)
    .replace(/[\s  ]/g, '')
    .replace(/kr$/i, '')
    .replace(',', '.');
  if (!cleaned) return null;
  const parsed = Number(cleaned);
  return Number.isFinite(parsed) ? parsed : null;
};
